module.exports = __webpack_public_path__ + "img/icon_param.9b8f42fd.svg";